"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }
var _upgrade = require('shared/enum/upgrade');
var _upgradeNotices = require('shared/constants/upgradeNotices');
var _lodash = require('lodash');
var _amplitude = require('web/services/amplitude'); var _amplitude2 = _interopRequireDefault(_amplitude);

 const FREE_CAP_ANALYTICS_SOURCE = 'free_cap_locked_chat'; exports.FREE_CAP_ANALYTICS_SOURCE = FREE_CAP_ANALYTICS_SOURCE
 const FREE_CAP_ANALYTICS_SURFACE = 'locked_chat'; exports.FREE_CAP_ANALYTICS_SURFACE = FREE_CAP_ANALYTICS_SURFACE
 const FREE_CAP_POLICY_VERSION = 'free_cap_10_current'; exports.FREE_CAP_POLICY_VERSION = FREE_CAP_POLICY_VERSION

 const FREE_CAP_ANALYTICS_EVENTS = {
  lockedChatShown: 'FREE_CAP_LOCKED_CHAT_SHOWN',
  lockedChatUpgradeClicked: 'FREE_CAP_LOCKED_CHAT_UPGRADE_CLICKED',
  teamCommunicationUpgradeStep: 'TEAM_COMMUNICATION_UPGRADE_STEP',
  lockedChatCheckoutStarted: 'FREE_CAP_LOCKED_CHAT_CHECKOUT_STARTED',
  lockedChatUpgradeSucceeded: 'FREE_CAP_LOCKED_CHAT_UPGRADE_SUCCEEDED',
} 











; exports.FREE_CAP_ANALYTICS_EVENTS = FREE_CAP_ANALYTICS_EVENTS

const compact = (props) =>
  Object.entries(props).reduce(
    (acc, [key, value]) => {
      if (!_lodash.isNil.call(void 0, value)) acc[key] = value
      return acc
    },
    {},
  )

 const isFreeCapAnalyticsContext = (
  context,
) =>
  _optionalChain([context, 'optionalAccess', _ => _.source]) === exports.FREE_CAP_ANALYTICS_SOURCE; exports.isFreeCapAnalyticsContext = isFreeCapAnalyticsContext

 const getMemberCountBucket = (memberCount) => {
  if (typeof memberCount !== 'number' || !Number.isFinite(memberCount)) {
    return undefined
  }

  if (memberCount <= _upgradeNotices.OVER_LIMIT_MEMBERS_THRESHOLD) return '0-10'
  if (memberCount <= 15) return '11-15'
  if (memberCount <= 25) return '16-25'
  if (memberCount <= 50) return '26-50'
  return '51+'
}; exports.getMemberCountBucket = getMemberCountBucket

const getActorRole = (isAdmin) => {
  if (isAdmin === undefined) return undefined
  return isAdmin ? 'admin' : 'non_admin'
}

 const makeFreeCapAnalyticsProperties = (
  context,
  extra = {},
) => compact({
  source: context.source || exports.FREE_CAP_ANALYTICS_SOURCE,
  surface: exports.FREE_CAP_ANALYTICS_SURFACE,
  upgrade_type: _upgrade.SubscriptionItemType.TEAM,
  app: 'web',
  org_key: context.orgKey,
  active_member_count: context.activeMemberCount,
  member_count_bucket: exports.getMemberCountBucket.call(void 0, context.activeMemberCount),
  free_cap: _nullishCoalesce(context.freeCap, () => ( _upgradeNotices.OVER_LIMIT_MEMBERS_THRESHOLD)),
  is_admin: context.isAdmin,
  actor_role: getActorRole(context.isAdmin),
  policy_version: exports.FREE_CAP_POLICY_VERSION,
  ...extra,
}); exports.makeFreeCapAnalyticsProperties = makeFreeCapAnalyticsProperties

const trackFreeCapEvent = (
  eventName,
  context,
  extra,
) => _amplitude2.default.logEvent(
  eventName,
  exports.makeFreeCapAnalyticsProperties.call(void 0, context, extra),
)

 const trackFreeCapLockedChatShown = (
  context,
) => trackFreeCapEvent(exports.FREE_CAP_ANALYTICS_EVENTS.lockedChatShown, context); exports.trackFreeCapLockedChatShown = trackFreeCapLockedChatShown

 const trackFreeCapLockedChatUpgradeClicked = (
  context,
) => trackFreeCapEvent(exports.FREE_CAP_ANALYTICS_EVENTS.lockedChatUpgradeClicked, context); exports.trackFreeCapLockedChatUpgradeClicked = trackFreeCapLockedChatUpgradeClicked

 const trackTeamCommunicationUpgradeStep = (
  context,
  step,
  extra,
) => {
  if (!exports.isFreeCapAnalyticsContext.call(void 0, context)) return

  trackFreeCapEvent(
    exports.FREE_CAP_ANALYTICS_EVENTS.teamCommunicationUpgradeStep,
    context,
    {
      step,
      ...extra,
    },
  )
}; exports.trackTeamCommunicationUpgradeStep = trackTeamCommunicationUpgradeStep

 const trackFreeCapLockedChatCheckoutStarted = (
  context,
  extra,
) => {
  if (!exports.isFreeCapAnalyticsContext.call(void 0, context)) return

  trackFreeCapEvent(
    exports.FREE_CAP_ANALYTICS_EVENTS.lockedChatCheckoutStarted,
    context,
    extra,
  )
}; exports.trackFreeCapLockedChatCheckoutStarted = trackFreeCapLockedChatCheckoutStarted

 const trackFreeCapLockedChatUpgradeSucceeded = (
  context,
  planTypes,
  actionType,
) => {
  if (
    !exports.isFreeCapAnalyticsContext.call(void 0, context)
    || !planTypes.includes(_upgrade.SubscriptionItemType.TEAM)
    || actionType !== _upgrade.CheckoutActionType.UPGRADE
  ) return

  trackFreeCapEvent(
    exports.FREE_CAP_ANALYTICS_EVENTS.lockedChatUpgradeSucceeded,
    context,
    {
      plan_type: planTypes.join(','),
      action_type: actionType,
    },
  )
}; exports.trackFreeCapLockedChatUpgradeSucceeded = trackFreeCapLockedChatUpgradeSucceeded
